import { Flex, Form, FormActions, Modal } from 'ui';
import {
  ChatGroupAddMembersSelect,
  type ExtendedChatGroupAddMembersFormValues,
} from '../chat-group-add-members-select';
import { ChatGroupAddMembersSelectedList } from '../chat-group-add-members-selected-list';

export type ChatGroupAddMembersFormValues = ExtendedChatGroupAddMembersFormValues;

type P = {
  isPending: boolean;
  onCancel: () => void;
  onFinish: (values: ChatGroupAddMembersFormValues) => void;
};

const ChatGroupAddMembersFormContent = ({ isPending, onCancel, onFinish }: P) => {
  const [form] = Form.useForm<ChatGroupAddMembersFormValues>();

  return (
    <Form<ChatGroupAddMembersFormValues> form={form} onFinish={onFinish}>
      <Flex gap="md" vertical>
        <Form.Item<ChatGroupAddMembersFormValues> label="Search members" marginBottom={false} name="users" noOptional>
          <ChatGroupAddMembersSelect<ChatGroupAddMembersFormValues> />
        </Form.Item>
        <ChatGroupAddMembersSelectedList<ChatGroupAddMembersFormValues> />
      </Flex>
      <Modal.HugContent.Footer>
        <FormActions
          right={{ children: 'Cancel', onClick: onCancel }}
          submit={{ children: 'Add', loading: isPending }}
        />
      </Modal.HugContent.Footer>
    </Form>
  );
};

export default ChatGroupAddMembersFormContent;
